import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

import ConfirmationDialog from "Components/Common/ConfirmationDialog";
import { SUPER_ADMIN } from "common/constant";

import { isAuthorizedUser } from "utils";
import { getUtilityWiseRoles } from "utils/getUtilityWiseRoles";

import { usePutSettlementChargeDocumentApproveMutation } from "apis/DemandEstimation";

const SettlementChargeApproveButtons = ({
  DemandEstimationData: {
    applicationId,
    isSettlementConnectionChargeDocumentApproved,
    utilities,
  },
  handleClose,
  t,
}) => {
  const [isApproveButtonClicked, setIsApproveButtonClicked] = useState(false);

  const [approveSettlementCharge, { isLoading: isSettlementApproveLoading }] =
    usePutSettlementChargeDocumentApproveMutation();

  const { roles } = useSelector((state) => state.Login);

  const submitHandlerForApproval = async () => {
    try {
      await approveSettlementCharge(applicationId);
      setIsApproveButtonClicked(false);
      handleClose();
    } catch (err) {}
  };

  return (
    <>
      {isApproveButtonClicked && (
        <ConfirmationDialog
          message="Are you sure you want to approve Settlement Charge document?"
          onCancel={() => {
            setIsApproveButtonClicked(false);
          }}
          onConfirm={submitHandlerForApproval}
          isOpen={isApproveButtonClicked}
          title="Warning"
          variant="warning"
          isLoading={isSettlementApproveLoading}
        />
      )}

      {!isSettlementConnectionChargeDocumentApproved &&
        isAuthorizedUser(roles, [
          ...getUtilityWiseRoles([utilities[0]]).admin3Roles,
          SUPER_ADMIN,
        ]) && (
          <div className="text-end">
            <Button
              variant="contained"
              className="mt-2 "
              color="success"
              onClick={() => {
                setIsApproveButtonClicked(true);
              }}
            >
              {t("Approve")}
            </Button>
          </div>
        )}
    </>
  );
};

SettlementChargeApproveButtons.propTypes = {
  DemandEstimationData: PropTypes.object,
  handleClose: PropTypes.func,
  t: PropTypes.func,
};
export default withTranslation()(SettlementChargeApproveButtons);
